// @ts-nocheck
import { useCallback, useState } from 'react';
import { Upload } from 'lucide-react';

interface FileUploadProps {
  accept?: string;
  onFile: (file: File) => void;
  label?: string;
}

export function FileUpload({ accept = '.xlsx,.xls', onFile, label = 'Upload XLSX File' }: FileUploadProps) {
  const [dragging, setDragging] = useState(false);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      setDragging(false);
      const file = e.dataTransfer.files[0];
      if (file) onFile(file);
    },
    [onFile]
  );

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) onFile(file);
    },
    [onFile]
  );

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors cursor-pointer ${
        dragging ? 'border-blue-400 bg-blue-50' : 'border-gray-300 hover:border-gray-400'
      }`}
    >
      <Upload className="mx-auto text-gray-400 mb-3" size={32} />
      <p className="text-sm text-gray-600 mb-2">{label}</p>
      <p className="text-xs text-gray-400 mb-4">Drag and drop or click to browse</p>
      <label className="inline-block px-4 py-2 bg-blue-600 text-white rounded-lg text-sm cursor-pointer hover:bg-blue-700">
        Choose File
        <input type="file" accept={accept} onChange={handleChange} className="hidden" />
      </label>
    </div>
  );
}
